export default {
  setUsersData(state, data) {
    state.usersData = data;
  },
  async setUserReputationScores(state, data) {
    data = await data.map((label, i) => ({
      date: Date.parse(data[i].date),
      data: {
        Insightfulness: data[i]?.reputationScores[2]?.score ? data[i]?.reputationScores[2]?.score : 0,
        Relevance: data[i]?.reputationScores[3]?.score ? data[i]?.reputationScores[3]?.score : 0,
        Politeness: data[i]?.reputationScores[4]?.score ? data[i]?.reputationScores[4]?.score : 0,
      },
    }));
    let apiData = {};
    apiData.historical = data;
    state.userReputationScores = apiData;
  },
};
